<input
	type="date"
	[placeholder]="placeholder"
	#valueInput
	(input)="search(valueInput.value)"
	[style.width]="width"
	class="form-control form-control-sm"
	[value]="value"
/>
